import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

function EditAgencyOfficials() {
  const {plantName, official_id, id } = useParams(); // Get both params
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    renew_officials_name: '',
    renew_officials_designation: '',
    renew_officials_phone: '',
    renew_officials_email: '',
  });

  const [errors, setErrors] = useState({});
  const [statusMessage, setStatusMessage] = useState('');

  // Fetch official data
  useEffect(() => {
    if (!official_id) return;

    const fetchOfficial = async () => {
      try {
        const res = await axios.get(
          `https://backend-zkgn.onrender.com/api/renewable-agency-officials/view/${official_id}`
        );
        setFormData(res.data);
      } catch (error) {
        console.error('Error fetching official data:', error.message);
        setStatusMessage('Failed to fetch official data');
      }
    };

    fetchOfficial();
  }, [official_id]);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Validation
  const validate = () => {
    let tempErrors = {};
    let isValid = true;

    if (!formData.renew_officials_designation.trim()) {
      tempErrors.renew_officials_designation = 'Designation is required.';
      isValid = false;
    }
    if (!formData.renew_officials_name.trim()) {
      tempErrors.renew_officials_name = "Official's Name is required.";
      isValid = false;
    }
    if (
      formData.renew_officials_email &&
      !/\S+@\S+\.\S+/.test(formData.renew_officials_email)
    ) {
      tempErrors.renew_officials_email = 'Enter a valid email address.';
      isValid = false;
    }

    setErrors(tempErrors);
    return isValid;
  };

  // Submit form
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    try {
      await axios.put(
        `https://backend-zkgn.onrender.com/api/renewable-agency-officials/update/${official_id}`,
        formData
      );

      setStatusMessage('Official updated successfully!');
      setTimeout(() => setStatusMessage(''), 3000);

      navigate(`/renewableagency-officials/${plantName}/${id}`); // redirect to list
    } catch (error) {
      console.error('Error updating official:', error.message);
      setStatusMessage('Failed to update official.');
    }
  };

  return (
    <div className="container my-5">
      <h4 className="mb-4 text-center">Edit Renewable Agency Official</h4>

      {statusMessage && (
        <div className="alert alert-info text-center">{statusMessage}</div>
      )}

      <form onSubmit={handleSubmit} className="shadow p-4 rounded bg-light">
        <div className="row g-3">
          <div className="col-md-6">
            <label className="form-label">Designation</label>
            <input
              type="text"
              name="renew_officials_designation"
              className="form-control"
              value={formData.renew_officials_designation || ''}
              onChange={handleChange}
            />
            {errors.renew_officials_designation && (
              <small className="text-danger">
                {errors.renew_officials_designation}
              </small>
            )}
          </div>

          <div className="col-md-6">
            <label className="form-label">Official's Name</label>
            <input
              type="text"
              name="renew_officials_name"
              className="form-control"
              value={formData.renew_officials_name || ''}
              onChange={handleChange}
            />
            {errors.renew_officials_name && (
              <small className="text-danger">
                {errors.renew_officials_name}
              </small>
            )}
          </div>

          <div className="col-md-6">
            <label className="form-label">Email (Optional)</label>
            <input
              type="email"
              name="renew_officials_email"
              className="form-control"
              value={formData.renew_officials_email || ''}
              onChange={handleChange}
            />
            {errors.renew_officials_email && (
              <small className="text-danger">
                {errors.renew_officials_email}
              </small>
            )}
          </div>

          <div className="col-md-6">
            <label className="form-label">Phone Number (Optional)</label>
            <input
              type="text"
              name="renew_officials_phone"
              className="form-control"
              value={formData.renew_officials_phone || ''}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="text-center mt-4">
          <button type="submit" className="btn btn-success px-4">
            Update Official
          </button>
        </div>
      </form>
    </div>
  );
}

export default EditAgencyOfficials;
